import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { ConsentTypeDataProvider } from "../../data-provider/consent-type.dp";
import { ContactMethodDataProvider } from "../../data-provider/contact-method.dp";
import { EmploymentStatusDataProvider } from "../../data-provider/employment-status.dp";
import { ElectionDataProvider } from "../../data-provider/election.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { Field } from "../../models/field.model";
import { HouseOccupant } from "../../models/house-occupant.model";
import { PermissionCheck } from "../../shared/permission";
import { CustomFieldService } from "../../services/custom-field.service";
import { HouseOccupantService } from "../../services/house-occupant.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { FormUtils } from "../../helper/form.helper";
import { creditRatings } from "../../utils/constants/fields.constants";
import { prospectorEditDisabledMessage } from "../../utils/constants/prospector.constants";

let HouseOccupantFormComponent = {
    selector: "vcHouseOccupantForm",
    templateUrl:
        "/angular/components/house-occupant/house-occupant-form.component.html",
    bindings: {
        selectedHoid: "=?",
        selectedHid: "=?",
    },
    controller: class HouseOccupantFormController {
        // * bindings for typescript compiler *
        public selectedHoid?: any;
        public selectedHid?: any;
        // ************************************

        public loadedConsent: object[] = [];
        public campaignStatusId: string;
        public saving = false;
        public missingCustomField: string | undefined = undefined;
        public contactFields: Field[] = [];
        public generalFields: Field[] = [];
        public otherFields: Field[] = [];
        public editho: HouseOccupant;
        public hofname: string;
        public product: any;
        public fields: Field[] = [];
        public employmentstatuses: any[] = [];
        public houseOccupantForm: any;
        public consentTypes: object[] | undefined = undefined;
        public errors: any[] | undefined;
        public consentSettings: any;

        private $scope: any;
        private __env: any;
        private dialog: DialogUtils;
        private modelsUtils: any;
        private formUtils: FormUtils;

        public consentTypeDataProvider: ConsentTypeDataProvider;
        public resource: HouseOccupantService;
        public customFieldService: CustomFieldService;
        public fieldDataProvider: FieldDataProvider;
        public contactMethodDataProvider: ContactMethodDataProvider;
        public electionDataProvider: ElectionDataProvider;
        public employmentStatusDataProvider: EmploymentStatusDataProvider;
        public campaignDataProvider: CampaignDataProvider;
        public permissionProvider: PermissionCheck;
        public creditRatings: string[];
        public prospectorEditDisabledMessage: string =
            prospectorEditDisabledMessage;

        constructor(
            $scope: any,
            EmploymentStatusDataProvider: EmploymentStatusDataProvider,
            ConsentTypeDataProvider: ConsentTypeDataProvider,
            HouseOccupantService: HouseOccupantService,
            CustomFieldService: CustomFieldService,
            FieldDataProvider: FieldDataProvider,
            ContactMethodDataProvider: ContactMethodDataProvider,
            ElectionDataProvider: ElectionDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            __env: any,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils,
            ModelsUtils: any,
            FormUtils: FormUtils
        ) {
            this.$scope = $scope;
            this.consentTypeDataProvider = ConsentTypeDataProvider;
            this.resource = HouseOccupantService;
            this.customFieldService = CustomFieldService;
            this.fieldDataProvider = FieldDataProvider;
            this.contactMethodDataProvider = ContactMethodDataProvider;
            this.electionDataProvider = ElectionDataProvider;
            this.employmentStatusDataProvider = EmploymentStatusDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.__env = __env;
            this.permissionProvider = PermissionCheck;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;
            this.formUtils = FormUtils;
            this.creditRatings = creditRatings;

            this.campaignStatusId =
                this.campaignDataProvider.activeCampaign.campaignstatusid;

            this.fieldDataProvider.getAllFields(true).then(() => {
                [this.contactFields, this.generalFields, this.otherFields] =
                    this.fieldDataProvider.combinedFields;
            });

            this.product = this.__env.product;
            this.fieldDataProvider.getAllFields().then((fields: object) => {
                this.fields = fields["nonpriority"].concat(fields["priority"]);
            });

            this.employmentStatusDataProvider
                .all()
                .then((statuses: object[]) => {
                    this.employmentstatuses = statuses;
                });
            PermissionCheck.getConsentSettings().then(
                (consentSettings: any) =>
                    (this.consentSettings = consentSettings)
            );
        }

        $onInit() {
            this.editho = this.modelsUtils.houseOccupant({
                hid: this.selectedHid,
            });
            this.hofname = this.editho.hofname;

            if (this.selectedHoid) {
                this.resource
                    .info(this.selectedHoid)
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.editho = this.modelsUtils.houseOccupant(
                                json.data
                            );
                            if (this.editho.consentTypes)
                                this.populateConsent(this.editho.consentTypes);

                            if (
                                angular.isDefined(this.editho.hodob) &&
                                this.editho.hodob
                            ) {
                                this.splitDOB();
                            }
                        }
                    });
            } else {
                this.contactMethodDataProvider
                    .all()
                    .then((contactMethods: object[]) => {
                        this.editho.contactmethods = contactMethods;
                    });

                this.fieldDataProvider
                    .getCustomFields()
                    .then((customFields: Field[]) => {
                        // Reset custom field values
                        this.editho.customfields = customFields.map(
                            (field: Field) => {
                                delete field.hocfvalue;
                                delete field.option;

                                if (field.options) {
                                    field.options = field.options.map(
                                        (option: any) => {
                                            option.selected =
                                                option.cfodefault == 1
                                                    ? "1"
                                                    : 0;
                                            return option;
                                        }
                                    );
                                }

                                return field;
                            }
                        );
                    });

                this.electionDataProvider
                    .getAllElections()
                    .then((elections: any[]) => {
                        this.editho.elections = elections;
                    });
            }

            this.$scope.$watch(
                () => this.editho,
                (newValue: HouseOccupant, oldValue: HouseOccupant) => {
                    if (newValue && oldValue) {
                        if (newValue.hoemail != oldValue.hoemail) {
                            this.houseOccupantForm.hoemail.$setValidity(
                                "uniqueEmail",
                                true
                            );
                            this.houseOccupantForm.hoemail.$setValidity(
                                "badEmail",
                                true
                            );
                        }
                        if (newValue.homobilephone != oldValue.homobilephone) {
                            this.houseOccupantForm.homobilephone.$setValidity(
                                "uniqueMobilePhone",
                                true
                            );
                        }
                        if (newValue.hovoterid != oldValue.hovoterid) {
                            this.houseOccupantForm.hovoterid.$setValidity(
                                "uniqueHoVoterid",
                                true
                            );
                        }
                        if (
                            newValue.hoybirthday != oldValue.hoybirthday ||
                            newValue.hombirthday != oldValue.hombirthday ||
                            newValue.hodbirthday != oldValue.hodbirthday
                        ) {
                            if (
                                newValue.hoybirthday &&
                                newValue.hombirthday &&
                                newValue.hodbirthday
                            ) {
                                this.validateBirthday();
                            }
                        }
                    }
                },
                true
            );
        }

        dismissDialog(): void {
            this.dialog.cancel();
        }

        getField(keyOrId: string): Field {
            return (
                this.fields.filter((field: Field) => {
                    if (isNaN(parseInt(keyOrId))) {
                        return field.hokey == keyOrId;
                    } else {
                        return field.cfid == keyOrId;
                    }
                })[0] || new Field({})
            );
        }

        isReadOnly(keyOrId: string): boolean {
            if (this.isProspectorField(keyOrId)) {
                return true;
            }
            if (["fname", "lname"].indexOf(keyOrId) > -1) {
                return (
                    false ===
                    this.permissionProvider.hasPermission("EDIT_VOTER_NAME")
                );
            }

            return this.getField(keyOrId).readonly === "1";
        }

        isProspectorField(key: string): boolean {
            let prospectorDisabledFields = [
                "fname",
                "lname",
                "gender",
                "mobilephone",
                "homephone",
                "party",
                "credit_rating",
                "income",
                "dob",
                "yob",
                "donor_environmental",
            ];
            if (
                this.editho.unique_id &&
                prospectorDisabledFields.includes(key)
            ) {
                return true;
            }
            return false;
        }

        getReadOnlyMessage(key: string): string {
            if (this.isProspectorField(key)) {
                return this.prospectorEditDisabledMessage;
            } else {
                return "This field is read-only";
            }
        }

        validateRequiredCustomFields(): boolean {
            for (const customField of this.editho.customfields) {
                if (!this.isRequired(customField.cfid)) {
                    continue;
                }

                if (customField.cftid == "6" && !customField.hocfvalue) {
                    this.missingCustomField = customField.cfid;
                    return false;
                }

                if (
                    (customField.cftid == "4" || customField.cftid == "5") &&
                    !this.customFieldOptionSelected(customField)
                ) {
                    this.missingCustomField = customField.cfid;
                    return false;
                }
            }
            this.missingCustomField = undefined;
            return true;
        }

        customFieldOptionSelected(customField: Field): boolean {
            for (const option of customField.options) {
                if (option.selected == "1") {
                    return true;
                }
            }
            return false;
        }

        isRequired(keyOrId: string): boolean {
            if (this.isProspectorField(keyOrId)) {
                return false;
            }

            if (["fname", "lname"].indexOf(keyOrId) > -1) {
                return (
                    true ===
                    this.permissionProvider.hasPermission("EDIT_VOTER_NAME")
                );
            }

            return this.getField(keyOrId).required === "1";
        }

        splitDOB(): void {
            if (angular.isDefined(this.editho.hodob)) {
                const pieces = this.editho.hodob.split("-");
                if (pieces.length == 3) {
                    this.editho.hoybirthday = pieces[0];
                    this.editho.hombirthday = pieces[1];
                    this.editho.hodbirthday = pieces[2];

                    if (this.editho.hombirthday.length === 1) {
                        this.editho.hombirthday = "0" + this.editho.hombirthday;
                    }
                }
            }
        }

        populateConsent(hoConsentTypes: any[]): void {
            this.consentTypeDataProvider
                .all()
                .then((consentTypes: object[]) => {
                    this.consentTypes = consentTypes;

                    angular.forEach(hoConsentTypes, (hoConsentType: any) => {
                        angular.forEach(
                            this.consentTypes,
                            (consentType: any) => {
                                if (hoConsentType.id == consentType.id) {
                                    consentType.checked = true;
                                }
                            }
                        );
                    });
                });
        }

        selectedOption(options: object[]): object | null {
            let selectedOptions = options.filter((option: any) => {
                return option.selected == 1;
            });
            return selectedOptions.length > 0 ? selectedOptions[0] : null;
        }

        setSelectedOption(options: object[], selectedOption?: any): void {
            angular.forEach(options, (option: any) => {
                option.selected = 0;
            });

            if (selectedOption) selectedOption.selected = 1;
        }

        updateEmploymentStatusName(): void {
            if (
                !angular.isUndefined(this.editho.esid) &&
                this.editho.esid > 0
            ) {
                this.editho.esname =
                    this.employmentstatuses[this.editho.esid - 1].esname;
            }
        }

        saveHouseOccupant(): void {
            this.errors = [];

            if (!this.validateBirthday()) {
                return;
            }
            this.saving = true;

            if (this.consentTypes) {
                this.editho.consentTypes = this.consentTypes.filter(
                    (consentType: any) => {
                        return consentType.checked;
                    }
                );
            }

            if (!angular.isUndefined(this.editho.hoid) && this.editho.hoid) {
                this.updateHouseOccupant(this.editho);
            } else {
                this.createHouseOccupant(this.editho);
            }
        }

        updateHouseOccupant(houseoccupant: HouseOccupant): void {
            houseoccupant.holastmodifieddatetime = null;
            this.resource.update(houseoccupant).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    houseoccupant.setData(json.data);
                    this.dialog.hide(houseoccupant);
                } else if (json.errorCode == 0) {
                    this.houseOccupantForm.homobilephone.$setValidity(
                        "uniqueMobilePhone",
                        false
                    );
                } else if (json.errorCode == 1) {
                    this.houseOccupantForm.hoemail.$setValidity(
                        "uniqueEmail",
                        false
                    );
                } else if (json.errorCode == 2) {
                    this.houseOccupantForm.hoemail.$setValidity(
                        "badEmail",
                        false
                    );
                } else if (json.errorCode == 3) {
                    this.houseOccupantForm.hovoterid.$setValidity(
                        "uniqueHoVoterid",
                        false
                    );
                    this.houseOccupantForm.hid = json.data[0].hid;
                    this.houseOccupantForm.hoid = json.data[0].hoid;
                }
                this.saving = false;
            });
        }

        createHouseOccupant(houseoccupant: HouseOccupant): void {
            this.resource.create(houseoccupant).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    houseoccupant.hoid = json.id;
                    houseoccupant.contactmethods = json.data.contact_methods;
                    houseoccupant.customfields = json.data.customfields;
                    this.dialog.hide(houseoccupant);
                    this.saving = false;
                } else if (json.errorCode == 0) {
                    this.houseOccupantForm.homobilephone.$setValidity(
                        "uniqueMobilePhone",
                        false
                    );
                } else if (json.errorCode == 1) {
                    this.houseOccupantForm.hoemail.$setValidity(
                        "uniqueEmail",
                        false
                    );
                } else if (json.errorCode == 2) {
                    this.houseOccupantForm.hoemail.$setValidity(
                        "badEmail",
                        false
                    );
                } else if (json.errorCode == 3) {
                    this.houseOccupantForm.hovoterid.$setValidity(
                        "uniqueHoVoterid",
                        false
                    );
                    this.houseOccupantForm.hid = json.data[0].hid;
                    this.houseOccupantForm.hoid = json.data[0].hoid;
                }
                this.saving = false;
            });
        }

        validateBirthday(): boolean {
            if (
                !(
                    (angular.isDefined(this.editho.hoybirthday) &&
                        this.editho.hoybirthday != "") ||
                    (angular.isDefined(this.editho.hombirthday) &&
                        this.editho.hombirthday != "") ||
                    (angular.isDefined(this.editho.hodbirthday) &&
                        this.editho.hodbirthday != "")
                )
            ) {
                //None of the 3 inputs has data don't validate.
                this.editho.hodob = null;
                return true;
            }

            let dateString =
                this.editho.hoybirthday +
                "-" +
                this.editho.hombirthday +
                "-" +
                this.editho.hodbirthday;
            const regEx =
                /^[0-9]{4}\-(0[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])/;
            if (dateString.match(regEx)) {
                let date = new Date(
                    this.editho.hoybirthday,
                    parseInt(this.editho.hombirthday) - 1,
                    this.editho.hodbirthday
                );
                if (
                    angular.isDate(date) &&
                    date.getDate() === parseInt(this.editho.hodbirthday) &&
                    date.getMonth() + 1 === parseInt(this.editho.hombirthday) &&
                    date.getFullYear() === parseInt(this.editho.hoybirthday)
                ) {
                    this.editho.hodob = dateString;
                    this.houseOccupantForm &&
                        this.houseOccupantForm.day.$setValidity(
                            "badDate",
                            true
                        );
                    return true;
                }
            }
            this.houseOccupantForm &&
                this.houseOccupantForm.day.$setValidity("badDate", false);
            return false;
        }

        searchCustomFieldValues(id: string, searchString: string): object {
            return this.customFieldService
                .searchValues({
                    id: id,
                    search: searchString,
                })
                .then((json: any) => {
                    return json.data.data;
                });
        }

        showConsentInfo(ev: object): void {
            const openInfoModal = this.dialog
                .confirm()
                .title("Consented Contact")
                .htmlContent(
                    '<p style="max-width: 500px">' +
                        "In compliance with Data Protection, you may only remove consented contact.<br/>" +
                        "You can capture consent, via the mobile app along with the " +
                        this.__env.strings.voter +
                        "'s e-signature."
                )
                .targetEvent(ev)
                .multiple(true)
                .ok("OK");
            this.dialog.showPreConfiguredDialog(openInfoModal);
        }

        openViewHouseOccupantDialog(
            houseoccupant: HouseOccupant,
            ev: object
        ): void {
            this.dialog
                .show({
                    component: "vc-view-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: true,
                    locals: {
                        selectedHoid: this.houseOccupantForm.hoid,
                    },
                    ariaLabel: "View Person",
                    size: "large",
                })
                .then((data: object) => houseoccupant.setData(data));
        }

        birthYearIsValid(inputField: any): boolean {
            const birthYear = parseInt(inputField.$modelValue);
            const valid = this.formUtils.birthYearValid(birthYear);
            inputField.$setValidity("badDate", valid);
            return valid;
        }

        validateForm(form: any): boolean {
            if (form.$valid) return true;

            this.formUtils.focusingFirstInvalid();
            return false;
        }
    },
};

angular
    .module("houseoccupant", ["checkManager", "angular-inview"])
    .component(HouseOccupantFormComponent.selector, HouseOccupantFormComponent);
